import { NEWS_PAGE_RECEIVE_NEWS_LIST, NEWS_PAGE_ERROR, NEWS_PAGE_CHANGE_CURRENTPAGE, NEWS_PAGE_RECEIVE_TOTAL_COUNT } from "./NewsPage.action";
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: [],
    totalCount: 0,
    currrentPage: 0,
}
export const NewsPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case NEWS_PAGE_RECEIVE_NEWS_LIST:

            return {
                ...state,
                result: action.payload,
            };
        case NEWS_PAGE_RECEIVE_TOTAL_COUNT:
            return {
                ...state,
                totalCount: action.payload
            };

        case NEWS_PAGE_CHANGE_CURRENTPAGE:
            return {
                ...state,
                currentPage: action.payload.currentPage
            };
        case NEWS_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        default:
            return state;
    }
};
